import { cn } from '@/lib/utils';

const pointsFor = (
  values: number[],
  width: number,
  height: number,
  padding: number,
): Array<[number, number]> => {
  const normalized =
    values.length > 1 ? values : [values[0] ?? 0, values[0] ?? 0];
  const maximum = Math.max(...normalized, 1);
  const minimum = Math.min(...normalized, 0);
  const span = Math.max(maximum - minimum, 1);

  return normalized.map((value, index) => [
    (index / (normalized.length - 1)) * width,
    padding + ((maximum - value) / span) * (height - padding * 2),
  ]);
};

export const Sparkline = ({
  values,
  className,
}: {
  values: number[];
  className?: string;
}) => {
  const width = 360;
  const height = 96;
  const points = pointsFor(values, width, height, 8);
  const line = points
    .map(([x, y], index) => `${index === 0 ? 'M' : 'L'} ${x} ${y}`)
    .join(' ');
  const area = `${line} L ${points.at(-1)?.[0] ?? width} ${height} L 0 ${height} Z`;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      className={cn('h-24 w-full', className)}
      role="img"
      aria-label="Visitor trend"
    >
      <path d={area} className="fill-accent/8" />
      <path
        d={line}
        fill="none"
        className="stroke-accent"
        strokeWidth="2"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
